import { Trans, useLingui } from '@lingui/react/macro';

import { InputSearchSelect } from '@/design_system/InputSearchSelect/InputSearchSelect';
import Stack from '@/design_system/Stack';
import Paragraph from '@/design_system/Typography/Paragraph';
import { ARTICLE_SERVICE_TYPES, type ArticleServiceType } from '@/models/article';

export const ServiceTypesInput = ({
  selectedServiceChoices,
  setSelectedServiceChoices,
}: {
  selectedServiceChoices: ArticleServiceType[];
  setSelectedServiceChoices: (serviceChoices: ArticleServiceType[]) => void;
}) => {
  const { t, i18n } = useLingui();

  return (
    <Stack gap="0.5rem">
      <Paragraph weight="medium">
        <Trans id="settings.organization.data-catalogs.condition-forms.detail.question.service-types.label">
          Service types:
        </Trans>
      </Paragraph>

      <InputSearchSelect
        isMulti
        placeholder={t({
          id: 'settings.organization.data-catalogs.condition-forms.detail.question.service-types.placeholder',
          message: 'Select service types',
        })}
        value={ARTICLE_SERVICE_TYPES.filter((articleServiceType) =>
          selectedServiceChoices.includes(articleServiceType.id)
        )}
        options={ARTICLE_SERVICE_TYPES.filter((articleServiceType) =>
          // At the moment, we only allow care-repair and exchange service types on Quality Control forms
          ['care-repair', 'exchange'].includes(articleServiceType.id)
        )}
        getOptionValue={(option) => option.id}
        getOptionLabel={(option) => i18n._(option.label)}
        onChange={(newOptions) =>
          setSelectedServiceChoices(newOptions.map((newOption) => newOption.id))
        }
        onRemoveValue={(valueToRemove) =>
          setSelectedServiceChoices(
            selectedServiceChoices.filter((serviceChoices) => serviceChoices !== valueToRemove)
          )
        }
      />
    </Stack>
  );
};
